<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 align-self-center>
        <v-card>
          <v-layout wrap py-8>
            <v-flex xs12 align-self-center text-center py-12 py-xl-16>
              <span class="title7">Partners</span>
            </v-flex>
            <v-flex xs12 align-self-center px-sm-2 px-xl-4>
              <v-card flat>
                <v-layout wrap>
                  <v-flex sm6 md4 py-2 lg4 px-2 px-xl-4>
                    <v-card
                      tile
                      :height="
                        $vuetify.breakpoint.name == 'lg'
                          ? '620px'
                          : $vuetify.breakpoint.name == 'xl'
                          ? '540px'
                          : $vuetify.breakpoint.name == 'md'
                          ? '720px'
                          : $vuetify.breakpoint.name == 'sm'
                          ? '690px'
                          : '756px'
                      "
                    >
                      <v-layout wrap>
                        <v-flex xs12 pa-16 align-self-center text-center>
                          <v-img
                            contain
                            height="75px"
                            :src="
                              require('./../../assets/images/YOTI_Logo.png')
                            "
                          ></v-img>
                        </v-flex>
                        
                        <v-flex xs12 align-self-center pb-8 px-3>
                          <span class="title8 mintext">
                            Committed to tech for good
                            <br />
                            <br v-if="$vuetify.breakpoint.name !== 'md'" />
                          </span>
                        </v-flex>
                        <v-flex text-justify xs12 px-8>
                          <span class="title9">
                            Yoti was founded on a strong set of principles that
                            we uphold to ensure we continue to only build tech
                            for good.
                            <br />
                            <br />
                            As a certified B Corp, we balance profit with people
                            and the planet. We are committed to solving identity
                            problems through grassroots research and social
                            purpose initiatives such as our Yoti Fellowship
                            Programme.
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <v-flex sm6 md4 py-2 lg4 px-2 px-xl-4>
                    <v-card
                      tile
                      :height="
                        $vuetify.breakpoint.name == 'lg'
                          ? '620px'
                          : $vuetify.breakpoint.name == 'xl'
                          ? '540px'
                          : $vuetify.breakpoint.name == 'md'
                          ? '720px'
                          : $vuetify.breakpoint.name == 'sm'
                          ? '690px'
                          : '756px'
                      "
                    >
                      <v-layout wrap>
                        <v-flex xs12 pa-16 align-self-center text-center>
                          <v-img
                            contain
                            height="75px"
                            :src="
                              require('./../../assets/images/BrightTideLogo.png')
                            "
                          ></v-img>
                        </v-flex>
                        <v-flex xs12 align-self-center pb-8 px-3>
                          <span class="title8 mintext">
                            Bright ideas can turnthetide for our planet.
                            <span v-if="$vuetify.breakpoint.name == 'xl'">
                              <br />
                              <br />
                            </span>
                          </span>
                        </v-flex>
                        <v-flex text-justify xs12 px-8>
                          <span class="title9">
                            Bright Tide works with businesses to address urgent
                            climate and biodiversity challenges around the
                            world.
                            <br />
                            <br />
                            We work with private sector clients to educate
                            employees (and their clients) about nature-based
                            solutions to climate change and host collaborative
                            events where employees can work together to develop
                            new solutions to global conservation issues.
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <v-flex sm6 md4 py-2 lg4 px-2 px-xl-4>
                    <v-card
                      tile
                      :height="
                        $vuetify.breakpoint.name == 'lg'
                          ? '620px'
                          : $vuetify.breakpoint.name == 'xl'
                          ? '540px'
                          : $vuetify.breakpoint.name == 'md'
                          ? '720px'
                          : $vuetify.breakpoint.name == 'sm'
                          ? '690px'
                          : '756px'
                      "
                    >
                      <v-layout wrap>
                        <v-flex xs12 pa-16 align-self-center text-center>
                          <v-img
                            contain
                            height="75px"
                            :src="
                              require('./../../assets/images/WTILogoHR.png')
                            "
                          ></v-img>
                        </v-flex>
                        <v-flex xs12 align-self-center pb-8>
                          <span class="title8 mintext">
                            In Service of Nature <br />
                            <br
                          /></span>
                        </v-flex>
                        <v-flex text-justify xs12 px-8>
                          <span class="title9">
                            Wildlife Trust of India (WTI) is a leading Indian
                            nature conservation organisation committed to the
                            service of nature. Its mission is to conserve
                            wildlife and its habitat and to work for the welfare
                            of individual wild animals, in partnership with
                            communities and governments. WTI’s team of 150
                            dedicated professionals work towards achieving its
                            vision of a secure natural heritage of India, in six
                            priority landscapes, knit holistically together by
                            nine key strategies or Big Ideas.
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <!-- <v-flex sm6  md6 py-2 lg3 px-2 px-xl-4>
                    <v-card tile height="756px">
                      <v-layout wrap>
                        <v-flex xs12 pa-16 align-self-center text-center>
                          <v-img
                            contain
                            height="75px"
                            :src="
                              require('./../../assets/images/LeopardLogo.png')
                            "
                          ></v-img>
                        </v-flex>
                        <v-flex xs12 align-self-center text-center pb-8>
                          <span class="title8 mintext"> Innovation Perfected <br> <br> </span>
                        </v-flex>
                        <v-flex text-justify xs12 px-8>
                          <span class="title9">
                            Leopard Tech Labs is a information technology
                            company based in Kottayam (Kerala, India). It was
                            founded in 2017 by two faculty members and two
                            alumni students of the Amal Jyothi College of
                            Engineering, Kanjirappally with a passion for
                            coding, yen for adventure and commitment to
                            conservation. This group is now putting technology
                            to work to empower individuals, enterprises and non-
                            profit organisations with tailor-made systems and
                            solutions for ease of operation.
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex> -->
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      vdo: ["./../../assets/videos/Tigers.mp4"],
    };
  },
};
</script>
